import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'

import firebase from 'firebase/app'
import 'firebase/auth'
import firestore from './firebase'

import axios from 'axios'
import moment from 'moment'

import Buefy, { ToastProgrammatic as Toast, DialogProgrammatic as Dialog, SnackbarProgrammatic as SnackBar } from 'buefy'
import 'buefy/dist/buefy.css'

import fontawesome from '@fortawesome/fontawesome'
import faRegular from '@fortawesome/fontawesome-free-regular'
import faSolid from '@fortawesome/fontawesome-free-solid'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import '@/assets/css/style.css'
import '@/assets/css/sdf.css'
import { Utils } from './utils/utils'
import './utils/filters.js'

import Loading from '@/components/global/Loading'
import BackButton from '@/components/global/BackButton'

Vue.component('loading', Loading)
Vue.component('back-button', BackButton)

console.time('authState')
console.time('appInit')

Vue.config.productionTip = false

fontawesome.library.add(faRegular, faSolid)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('fa', FontAwesomeIcon)
Vue.use(Buefy)

Vue.prototype.$firebase = firebase
Vue.prototype.$firestore = firestore
Vue.prototype.$fs = firestore
Vue.prototype.$http = axios
Vue.prototype.$utils = Utils
Vue.prototype.$ssToArr = Utils.snapshotToArr
Vue.prototype.$ssToObj = Utils.snapshotToObj
Vue.prototype.$dialog = Dialog
Vue.prototype.$toast = Toast
Vue.prototype.$snackbat = SnackBar
Vue.prototype.$moment = moment

Vue.prototype.$back = () => router.go(-1)

Vue.prototype.$showAlert = (msg, title = 'Alert', type = 'is-info') => {
  Dialog.alert({ type, title, message: msg.toString() })
}
Vue.prototype.$showError = (err, title = 'Error') => {
  Dialog.alert({ type: 'is-danger', title, message: err.message || err.toString() })
}
Vue.prototype.$log = msg => console.log(msg)
Vue.prototype.$confirm = (options) => {
  return new Promise(resolve => {
    options.onConfirm = () => resolve(true)
    options.onCancel = () => resolve(false)
    Dialog.confirm(options)
  })
}
Vue.prototype.$wait = (ms = 300) => new Promise(resolve => setTimeout(resolve, ms))

Vue.mixin({
  data () { return { subs: {} } },
  methods: {
    unsub (k) {
      if (typeof this.subs[k] === 'function') {
        console.log(`${this.$options.name} unsub: ${k}`)
        this.subs[k]()
        delete this.subs[k]
      }
    }
  },
  destroyed () {
    if (typeof this.subs !== 'object') return
    for (let k in this.subs) this.unsub(k)
  }
})

firebase.auth().onAuthStateChanged(authStateChanged)

let userSnapshotUnsubscribe = null
let app = null
function authStateChanged (user) {
  console.timeEnd('authState')
  if (user) {
    if (userSnapshotUnsubscribe) {
      userSnapshotUnsubscribe()
      userSnapshotUnsubscribe = null
    }
    userSnapshotUnsubscribe = firestore.collection('users')
      .doc(user.uid)
      .onSnapshot(snapshot => {
        store.dispatch('setUser', Utils.snapshotToObj(snapshot) || null)
        initApp()
      })

    user.getIdToken()
      .then(token => {
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
      })
  } else {
    store.dispatch('setUser', null)
    initApp()
    axios.defaults.headers.common['Authorization'] = ''
  }
}

function initApp () {
  if (app) return
  store.dispatch('init').then(() => {
    router.replace(store.getters.lastRouterPath)
    app = new Vue({
      store,
      router,
      render: h => h(App)
    }).$mount('#app')
  })
}
